import axios from 'axios';

/**
 * API to sending email for in product marketing.
 *
 * @method inProductMarketingSendEmailAPI
 * @param  {Object}  data
 * @return {Promise}
 */
export const inProductMarketingSendEmailAPI = data =>
    axios({
        method: 'post',
        url: '/tools/v1/in-product-marketing/send-email',
        data,
        type: 'apiTools',
        noBearer: true,
    });

/**
 * API to fetch upsell ads
 *
 * @method fetchUpsellAdsAPI
 * @return {Promise}
 */
export const fetchUpsellAdsAPI = () => {
    return axios({
        type: 'apiTools',
        method: 'get',
        url: `/tools/v1/in-product-marketing/upsell-ads`,
    });
};
